<template>
  <v-dialog
    :value="generalApp.isOverlayLoading || isLoading"
    persistent
    width="300"
  >
    <div style="position: absolute;left: 50%;top: 50%;">
      <v-progress-circular
        :size="60"
        color="white"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'wrld-overlay-loader',
  components: {},
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['generalApp'])
  },
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
